module.exports = __webpack_public_path__ + "img/life-buoy.49eae191.svg";